import React, { useState, useEffect, useMemo } from 'react';
import './BubbleInactivity.css';

const BubbleInactivity = ({ members = [], timeout = 10000 }) => {
    const [isActive, setIsActive] = useState(false);
    const [bubbles, setBubbles] = useState([]);

    const membersWithPhoto = useMemo(() => {
        const filtered = members.filter(m => m.photoUrl && String(m.photoUrl).length > 5);
        return filtered;
    }, [members]);

    useEffect(() => {
        let timer;
        const resetTimer = () => {
            setIsActive(false);
            clearTimeout(timer);
            timer = setTimeout(() => {
                setIsActive(true);
            }, timeout);
        };

        // Eventos que resetam a inatividade
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('mousedown', resetTimer);
        window.addEventListener('keypress', resetTimer);
        window.addEventListener('touchstart', resetTimer);

        resetTimer();

        return () => {
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('mousedown', resetTimer);
            window.removeEventListener('keypress', resetTimer);
            window.removeEventListener('touchstart', resetTimer);
            clearTimeout(timer);
        };
    }, [timeout]);

    // Quando ficar ativo, gera bolhas periodicamente
    useEffect(() => {
        if (!isActive || membersWithPhoto.length === 0) {
            setBubbles([]);
            return;
        }

        const createBubble = () => {
            const randomMember = membersWithPhoto[Math.floor(Math.random() * membersWithPhoto.length)];
            const id = Math.random().toString(36).substr(2, 9);
            const size = Math.floor(Math.random() * (90 - 55 + 1)) + 55; // 55px a 90px

            // Se for mobile, usa a tela quase toda. Se for tablet/desktop, foca na metade direita.
            const isMobile = window.innerWidth < 768;
            const minLeft = isMobile ? 10 : 50;
            const maxLeft = isMobile ? 85 : 92;

            const left = Math.floor(Math.random() * (maxLeft - minLeft + 1)) + minLeft;
            const duration = Math.floor(Math.random() * (14 - 8 + 1)) + 8; // 8s a 14s (um pouco mais lento)

            const newBubble = {
                id,
                photoUrl: randomMember.photoUrl,
                name: randomMember.firstName || "",
                size,
                left,
                duration
            };

            setBubbles(prev => [...prev.slice(-11), newBubble]); // Mantém no máximo 12 bolhas no DOM
        };

        const interval = setInterval(createBubble, 3500); // Nova bolha a cada 3.5s (mais espaçadas)
        createBubble(); // Cria a primeira imediatamente

        return () => clearInterval(interval);
    }, [isActive, membersWithPhoto]);

    if (!isActive || bubbles.length === 0) return null;

    return (
        <div className="bubble-container">
            {bubbles.map(bubble => (
                <div 
                    key={bubble.id}
                    className="soap-bubble"
                    style={{
                        width: `${bubble.size}px`,
                        height: `${bubble.size}px`,
                        left: `${bubble.left}%`,
                        animationDuration: `${bubble.duration}s`
                    }}
                >
                    <img 
                        src={bubble.photoUrl} 
                        alt={bubble.name} 
                        className="bubble-image"
                    />
                    <div className="bubble-reflection"></div>
                </div>
            ))}
        </div>
    );
};

export default BubbleInactivity;
